function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M110.002 26.334a3.5 3.5 0 00-2.667-3.389v-4.278a7.175 7.175 0 00-7.167-7.167h-7.313c-11.805-.04-46.15.05-66.708.002h-7.313a7.175 7.175 0 00-7.167 7.167v4.278A3.499 3.499 0 009 26.336a3.507 3.507 0 002.798 3.429l4.024 26.023a7.493 7.493 0 007.444 6.382h72.466a7.492 7.492 0 007.444-6.382l4.024-26.023a3.51 3.51 0 002.802-3.431z",
  fill: "#e6e7e8"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.669 24.834l4.144 26.799a6.533 6.533 0 006.456 5.535h72.466a6.532 6.532 0 006.456-5.535l4.144-26.799z",
  fill: "#6dc9f7"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.002 29.936l2.566 16.595a6.533 6.533 0 006.456 5.535h62.955a6.532 6.532 0 006.456-5.535l2.566-16.595z",
  fill: "#d4fbff"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25.024 52.066H35.98l9-22.13H34.024zm53-22.13l-9 22.13h3.956l9-22.13zm-23 0l-9 22.13H63.98l9-22.13z",
  fill: "#fff"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M96.169 8.501H14.835a6.167 6.167 0 00-6.167 6.167v5.167h93.667v-5.167a6.167 6.167 0 00-6.166-6.167z",
  fill: "#fa759e"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M102.502 24.834h-94a2.5 2.5 0 110-5h94a2.5 2.5 0 110 5z",
  fill: "#6dc9f7"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M37.002 19.834v5.458a7.625 7.625 0 007.625 7.625h21.75a7.625 7.625 0 007.625-7.625v-5.458z",
  fill: "#0089ef"
});

var _ref9 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#3a2c60"
}, React.createElement("path", {
  d: "M106.002 22.334a3.5 3.5 0 00-2.667-3.389v-4.278A7.175 7.175 0 0096.168 7.5c-28.99.159-54.223.002-81.334.002a7.175 7.175 0 00-7.167 7.167v4.278A3.499 3.499 0 005 22.336a3.507 3.507 0 002.798 3.429l4.024 26.022a7.492 7.492 0 007.444 6.382h72.466a7.492 7.492 0 007.444-6.382l4.024-26.022a3.51 3.51 0 002.802-3.431zM83.735 7.501c-60.155 44.667-30.078 22.333 0 0zM9.669 14.667A5.173 5.173 0 0114.836 9.5H96.17a5.173 5.173 0 015.167 5.167v4.167H9.669zm63.333 10.625a6.633 6.633 0 01-6.625 6.625h-21.75a6.633 6.633 0 01-6.625-6.625v-4.458h35zm-28.375 8.625h21.75a8.602 8.602 0 006.507-2.981h21.952l-2.388 15.441a5.504 5.504 0 01-5.468 4.688H24.024a5.503 5.503 0 01-5.468-4.688l-2.388-15.441H38.12a8.602 8.602 0 006.507 2.981zM7.002 22.334c0-.827.673-1.5 1.5-1.5h27.5v3h-27.5c-.827 0-1.5-.672-1.5-1.5zM97.203 51.48a5.504 5.504 0 01-5.468 4.688H19.269a5.503 5.503 0 01-5.468-4.688L9.835 25.834h26.194a8.544 8.544 0 00.791 3.102H15.002a.998.998 0 00-.988 1.153l2.566 16.594a7.492 7.492 0 007.444 6.382h62.955a7.492 7.492 0 007.444-6.382l2.566-16.594a1.003 1.003 0 00-.988-1.153H74.183a8.544 8.544 0 00.791-3.102h26.194zm5.299-27.646h-27.5v-3h27.5c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5z",
  fill: "#6dc9f7"
}), React.createElement("path", {
  d: "M46.763 27.136h17.478a1 1 0 000-2H46.763a1 1 0 000 2z"
}));

var Svg8Tupperware = function Svg8Tupperware(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    height: 278.08,
    viewBox: "0 0 115.002 69.52",
    width: 460.008,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(Svg8Tupperware, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/8-tupperware.e29fe7b1.svg";
export { ForwardRef as ReactComponent };